import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd66f89"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin-menu",
  class: "center-card"
}
const _hoisted_2 = { class: "admin-menu description-list" }
const _hoisted_3 = { class: "application-config-details" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "registration-status" }
const _hoisted_6 = {
  key: 0,
  class: "email-sending-status"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-exclamation-triangle",
  "aria-hidden": "true"
}, null, -1))

import { capitalize, toRefs, withDefaults } from 'vue'

  import AppStatsCards from '@/components/Administration/AppStatsCards.vue'
  import Card from '@/components/Common/Card.vue'
  import { IAppStatistics, TAppConfig } from '@/types/application'

  interface Props {
    appConfig: TAppConfig
    appStatistics?: IAppStatistics
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    appConfig: null,
    appStatistics: { default: () => ({} as IAppStatistics) }
  },
  setup(__props: any) {

const props = __props as { appConfig: TAppConfig, appStatistics: IAppStatistics }

  

  const { appConfig, appStatistics } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('admin.ADMINISTRATION')), 1)
      ]),
      content: _withCtx(() => [
        _createVNode(AppStatsCards, { appStatistics: _unref(appStatistics) }, null, 8, ["appStatistics"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, [
              _createVNode(_component_router_link, { to: "/admin/application" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('admin.APPLICATION')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("dd", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('admin.UPDATE_APPLICATION_DESCRIPTION')), 1),
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(
                    `admin.REGISTRATION_${
                      _unref(appConfig).is_registration_enabled ? 'ENABLED' : 'DISABLED'
                    }`
                  )), 1),
              (!_unref(appConfig).is_email_sending_enabled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.EMAIL_SENDING_DISABLED')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("dt", null, [
              _createVNode(_component_router_link, { to: "/admin/sports" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(capitalize(_ctx.$t('workouts.SPORT', 0))), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$t('admin.ENABLE_DISABLE_SPORTS')), 1),
            _createElementVNode("dt", null, [
              _createVNode(_component_router_link, { to: "/admin/users" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(capitalize(_ctx.$t('admin.USER', 0))), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("dd", null, _toDisplayString(_ctx.$t('admin.ADMIN_RIGHTS_DELETE_USER_ACCOUNT')), 1)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})